<template>
  <div class="search-reset-btn">
    <button class="btn reset-btn" @click="$emit('resetFilters')">
      {{ $t('main.RESET') }}
    </button>
    <button class="btn search-btn-wrap" @click="$emit('mobileSearchClick')">
      {{ $t('find.SEARCH') }}
    </button>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.search-reset-btn {
  padding: 16px;
  background: #f7f7f9;
  position: sticky;
  bottom: 0;
  display: grid;
  gap: 4px;
  margin-top: auto;
  grid-template-columns: repeat(2, 1fr);
}
.reset-btn {
  background: #e5e5e5;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
}

.search-btn-wrap {
  background: #ffe100;
  border-radius: 4px;
  border: none;
  color: #252525;
  font-weight: 700;
  font-size: 16px;
}
</style>
